// @flow
import Cookie from 'js-cookie';
const USER_SERVICE_TOKEN_NAME = 'user_service_token1';
// const USER_SERVICE_TOKEN_DOMAIN = 'powerreviews.com';

// we migrate to this approach
export const SessionTokenStorage = {
  getToken(): ?string {
    return window.sessionStorage.getItem('user_token') || undefined;
  },

  setToken(value: string) {
    window.sessionStorage.setItem('user_token', value);
  },

  clearToken() {
    return window.sessionStorage.removeItem('user_token');
  },
};

// this is a hack to enable session storage cookie managment in local development
// this hack will stop working once we stop setting the user_service_token1 cookie
// TOD
if (window.location.hostname === 'local.powerreviews.com') {
  let tokenFromSessionStorage = SessionTokenStorage.getToken();
  if (tokenFromSessionStorage === '%USER_TOKEN%') {
    let valueFromCookie = Cookie.get(USER_SERVICE_TOKEN_NAME);
    if (valueFromCookie != null) {
      window.sessionStorage.setItem('user_token', valueFromCookie);
      // Cookie.remove(USER_SERVICE_TOKEN_NAME, {
      //   domain: USER_SERVICE_TOKEN_DOMAIN,
      //   path: '/',
      // });
    }
  }
}

export default SessionTokenStorage;



// WEBPACK FOOTER //
// ./src/api/auth/TokenUtils.js